export default (state, action) => {
  switch (action.type) {
    case 'GO_TO_WELCOME_PAGE':
      return {
        ...state,
        curPage: 'welcomePage',
      };
    case 'GO_TO_REVIEW_ACCOUNT_PAGE':
      return {
        ...state,
        curPage: 'reviewAccountPage',
      };
    case 'GO_TO_ERROR_PAGE':
      return {
        ...state,
        curPage: 'errorPage',
        errorType: action.payload,
      };
    case 'GO_TO_SUCCESS_PAGE':
      return {
        ...state,
        curPage: 'successPage',
        productKey: action.payload,
        success: true,
      };
    case 'GO_TO_CREAT_CASE_SUCCESS_PAGE':
      return {
        ...state,
        curPage: 'createCaseSuccessPage',
        caseNumber: action.payload.caseNumber,
      };
    case 'GO_TO_SPIN_PAGE':
      return {
        ...state,
        curPage: 'processSpinPage',
      };
    case 'GO_TO_GATHER_INFO_PAGE':
      return {
        ...state,
        curPage: 'signInSpinPage',
      };
    case 'GO_TO_CREATE_CASE_PAGE':
      return {
        ...state,
        prevPage: state.curPage,
        curPage: 'createCasePage',
      };
    case 'GO_TO_CM_VALIDATION_PAGE':
      return {
        ...state,
        prevPage: state.curPage,
        curPage: 'cmValidation',
      };
    case 'GO_TO_NEW_CM_PAGE':
      return {
        ...state,
        prevPage: state.curPage,
        curPage: 'newCMInformation',
      };
    case 'GO_TO_AUTHORIZE_PAGE':
      return {
        ...state,
        prevPage: state.curPage,
        curPage: 'authorizeRequestPage',
      };
    case 'GO_TO_PREV_PAGE':
      return {
        ...state,
        curPage: state.prevPage,
      };
    case 'GO_TO_AGENT_AVAILABLE_PAGE': 
      return {
        ...state,
        curPage: 'agentAvailable'
      }
    default:
      return state;
  }
};
